import React from 'react';
import VenturiLoader from './VenturiLoader';

/**
 * CardLoader Component
 * Legacy wrapper rendering the unified VenturiLoader under the hood.
 * 
 * @param {Object} props
 * @param {string} props.message - Loading message
 */
const CardLoader = ({ message = 'Loading data...' }) => {
  return (
    <div className="card-loader" style={{ minHeight: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <VenturiLoader size="medium" message={message} />
    </div>
  );
};

export default CardLoader;
